/* eslint-disable */
import bi1_data_validation from '../base_i1_datavalidation'
import { RC, CR, AJRS } from '../base_i2_success_codes'
import base_i3_log from '../base_i3_logging'
import { ajax } from 'noquery-ajax'

function createOrganization(org_uid,name,description) {
    return new Promise(function (resolve, reject) {
        var return_msg = "";
        var debug_data = [];
        var task_id = "p2s1t27_CreateOrganization"

        ajax({
            url:  window.G_ajax_test_domain + '/console/p2s1t27-create_organization',
            method: 'POST',
            dataType: "text",
            headers: {
                'Authorization': 'Bearer ' + window.G_firebase_auth.IV_id_token
            },
            data: {
                "user_email":  window.G_firebase_auth.IV_email_address,
                "location": org_uid,
                "name": name,
                "description" : description
            },
            success: function(result) {
                if (result.includes('success')) {
                    return_msg += "Create Organization request has been sent. This can take a few minutes to show on dashboard..";
                    resolve(JSON.stringify({ success: RC.success, return_msg: return_msg, debug_data: debug_data }));
                } else {
                    return_msg += 'Error Creating Organization';
                    resolve(JSON.stringify({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data }));
                }
                //this has to be done since this is a legacy call an doesn't have auth caching
                window.G_firebase_auth.bi5VerifyToken();
            },
            error: function(result) {
                if (result.status === 401) {
                    window.G_firebase_auth.bi5forceTokenRefresh();
                }

                return_msg += "We are sorry there was an Error Creating Organization."
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
                //this has to be done since this is a legacy call an doesn't have auth caching
                reject(JSON.stringify({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data }));
                window.G_firebase_auth.bi5VerifyToken();
            }
        });
    });
}

export default createOrganization


// WEBPACK FOOTER //
// ./src/watchdog_includes/legacy_calls/p2s1t27_CreateOrganization.js